import React, { useEffect } from "react";

import { useAppSelector } from "../../redux/hooks";
import Login from "./Login";
import DemoUser from "./DemoUser";
import { useDispatch } from "react-redux";
import { commonActions } from "../../redux/features/common/commonSlice";

const Home = (props: any) => {
    const {login, showSnackbar, handleLoader, isMsgRequired, setIsMsgRequired, setMsgVisibility,loginType} = props;
    const dispatch = useDispatch();
    const isDemoUser = window.location.hostname.includes("demo") ? true: false;

    useEffect(() => {
        dispatch(commonActions.DEMO_USER(isDemoUser));
    },[]);
    return (
        isDemoUser ? <DemoUser login={login} showSnackbar={showSnackbar} handleLoader={handleLoader} isMsgRequired={isMsgRequired} setIsMsgRequired={setIsMsgRequired} setMsgVisibility={setMsgVisibility} /> : <Login login={login} showSnackbar={showSnackbar} handleLoader={handleLoader} isMsgRequired={isMsgRequired} setIsMsgRequired={setIsMsgRequired} setMsgVisibility={setMsgVisibility} loginType={loginType}/>
    );
};

export default Home;